const company = {
  company: {
    pageHeader: '会社概要',
    branchProfile: '支店概要',
    addBranchOffice: '支店の追加',
    companyDetails: '会社詳細',
    branchDetails: '支店詳細',
    companyName: '会社名',
    chamberofcommerce : '商工会議所番号',
    branchName: '支店名',
    websiteURL: 'ウェブサイトの URL',
    url: 'URL',
    yearFounded: '設立年',
    companyLogo: '会社ロゴ',
    imageFormatDescription: '4MB 以下の JPEG、GIF または PNG ファイルであること。',
    imageShapeDescription:
      '最良の結果を得るためには、少なくとも幅 400px、高さ 400px の、透明な背景を持つ正方形の画像をお勧めします。',
    noFile: 'ファイルが選択されていません',
    companyDescription: '会社概要',
    myTestEdit: '私のテスト編集',
    customerWelcomeEmail: '顧客歓迎のメールメッセージ',
    testEditMessage: 'メールメッセージのテスト編集',
    companyDescriptionTooltip:
      'ここに入力されたテキストは、貴社が設置したシステムの公開ビューに表示されます。これらのページへの訪問者からセールスリードを生み出すため、連絡先情報を含めるとよいでしょう。',
    editCompanyInformation: '会社情報の編集',
    welcomeEmailDescription:
      'ここに入力されたテキストは、Enlightenアカウント作成時に新規顧客に送信される歓迎メールに表示されます。このメッセージに会社のロゴを入れることもできます。',
    editWelcomeMessage: '顧客歓迎のメールメッセージを編集',
    checkboxDisplayLogo: '顧客歓迎メールに会社ロゴを表示',
    previewEmail: '顧客歓迎メールのプレビュー',
    contactDetails: '連絡先の詳細',
    streetAddress: '住所',
    streetAddress2: '住所2',
    city: '市区町村',
    zipCode: '郵便番号',
    customerSupport: 'カスタマーサポート連絡先',
    country: '国',
    state: '都道府県',
    contactOwnerDescription: 'システム所有者／住宅所有者用の連絡先',
    businessContacts: '企業向けの連絡先',
    sameCheckbox: 'カスタマーサポートに準ずる',
    contactEnphaseDescription: 'Enphaseの連絡先',
    installationDetails: '設置の詳細',
    servicesOffered: '提供サービス',
    installationType: '設置タイプ',
    salesEmployeeNumber: '営業部門の従業員数',
    workmanshipWarranty: '保証内容（年）',
    installationEmployeeNumber: '設置を行う従業員数',
    typicalInstallationsYear: '標準的な設置台数（年間）',
    typicalInstallationsMonth: '一般的な設置台数（kW/月）',
    enphaseShare: '設置台数におけるEnphaseの占有率',
    sgipDeveloper: 'お客様は SGIP の開発者ですか？',
    sgipDeveloperTooltip: 'selfgenca.comにSGIPデベロッパーとして登録されているかどうかを選択してください。',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'SGIPデベロッパーキー',
    businessLicenses: 'ビジネスライセンス',
    addNewLicense: '新しいライセンスを追加する',
    licenseType: 'ライセンスの種類',
    licenseNo: 'ライセンス番号',
    none: 'なし',
    licensingBoard: '認可委員会',
    licensingAuthority: '認可機関',
    expiryDate: '有効期限',
    profileLinks: 'プロファイルリンク',
    yelpAccountLink: 'Yelpアカウントリンク',
    rating: '評価：',
    reviews: 'レビュー：',
    yelpAccountLinkTooltip:
      'このリンクを取得するには、Yelp プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    yelpAccountLinkError: 'お客様の yelp プロファイルを取得できませんでした。入力されたプロファイルリンクを再度ご確認ください',
    googlePlaceId: 'GoogleプレイスID',
    clickHere: 'こちらをクリック',
    findPlaceId: 'googleプレイスIDを検索するには',
    placeIdError: 'このIDの有効な場所が見つかりませんでした。入力したIDを再度ご確認ください。',
    solarProfileLink: 'SolarReviewsプロファイルリンク',
    solarProfileLinkTooltip:
      'このリンクを取得するには、SolarReviews.com プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    bbbProfileLink: 'BBBプロファイルリンク',
    bbbProfileLinkTooltip:
      'このリンクを取得するには、BBB.org プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    solarQuotesProfileLink: 'Solarquotesプロファイルリンク',
    solarQuotesTooltip:
      'このリンクを取得するには、solarquotes.com.au プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    productReviewProfileLink: 'ProductReviewプロファイルリンク',
    productReviewTooltip:
      'このリンクを取得するには、productreview.com.au プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    trustPilotLink: 'Trustpilotプロファイルリンク',
    trustPilotTooltip:
      'このリンクを取得するには、trustpilot.com プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    facebookLink: 'Facebookプロファイルリンク',
    facebookTooltip:
      'このリンクを取得するには、facebook.com プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    justDialLink: 'Just Dialプロファイルリンク',
    justDialTooltip:
      'このリンクを取得するには、justdial.com プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください',
    listOfReferenceSystems: '参照システム一覧',
    referenceListDescription:
      'リファレンスリストは自動的に更新され、オーナーが共有することを選択したシステムが表示されます。記載されているシステムには、少なくとも100kWhの耐用年数エネルギーがあります',
    requestSystemAccess: 'システムアクセスのリクエスト',
    maintainer: '管理者',
    view_only: '閲覧のみ',
    linkRequestAccess: 'このリンクをシステムオーナーに送信して、Enlighten でのシステムへのアクセスをリクエストします',
    fieldRequired: 'このフィールドは必須です。',
    validEmail: '有効なメールアドレスを入力してください。',
    validPhone: '有効な電話番号を入力してください。',
    supportContact: '上記のうち少なくとも1つの欄（電話/Eメール）にご記入ください。',
    serviceRequired: '少なくとも1つのサービスタイプが必要です',
    installationRequired: '少なくとも1つの設置タイプが必要です',
    minLength: '最小許容長さは2です',
    maxLength: '最大許容長さは15です',
    dateWarning: '警告：有効期限が過ぎているため、このライセンスは失効したものとみなされます',
    correctValue: '次の値以下の値を入力してください ',
    feinLength: '9桁の数字を入力してください',
    less_than_25: '25%未満',
    between_25_50: '25%から50%',
    between_50_90: '50%から90%',
    greater_than_90: '90%以上',
    // TODO - new translations added (from french)
    roofingFr: 'QualiPV Bâtiment',
    solarFr: 'QualiPV Electricité (inférieur ou égale à 36kVA)',
    storageFr: 'QualiPV Electricité (supérieur à 36kVA ou inférieur ou égale à 250kVA)',
    electricalFr: 'QualiPV Electricité (supérieur à 250kVA)',
    othersFr: 'Autres',
    // TODO - new translations added (from french)
    roofing: '屋根',
    solar: 'ソーラー',
    storage: '蓄電池',
    electrical: '電気',
    ev_charger: 'EV充電器',
    others: 'その他',
    commercial: '商業用',
    residential: '住宅用',
    new_homes: '新築住宅',
    installer: '設置業者',
    roles_distributor: '販売業者',
    roles_support: 'サポート会社',
    cec: 'CEC',
    electrical_contract: '電気契約',
    abn_number: 'ABN番号',
    acn_number: 'ACN番号',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: '国を選択してください',
    yellowPageLink: 'イエローページのリンク',
    yellowPageTooltip: `このリンクを取得するには、https://www.pagesjaunes.fr/ プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください。`,
    enrQualityDirectoryLink: 'Annuary Qualit’Enr',
    enrQualityDirectoryTooltip: `このリンクを取得するには、https://www.qualit-enr.org/annuaire/ プロファイルにアクセスし、インターネットブラウザのアドレスバーにリンク/URLをコピーしてください。`,
    validChamberNumber: '無効な入力です!商工会議所番号には最低 8 文字が必要です',  
}
};

export default company;
